import { AfterViewInit, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { SecurityService } from '../../services/security.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { RouteService } from '../../services/route.service';
import { HelpService } from '../../services/help.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-finish',
  imports: [],
  templateUrl: './finish.component.html',
  styleUrl: './finish.component.css'
})
export class FinishComponent implements OnInit, AfterViewInit{
  nextRoute: WritableSignal<string> = signal('');

  constructor(
    private _router: Router,
    private _title: Title,
    private _securityService: SecurityService,
    private _loaderService: LoaderService,
    private _routeService: RouteService,
    private _helpService: HelpService

  ) {
    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
    this._title.setTitle('Onboarding Digital | Finalización');

   }

  async ngOnInit() {
    const authRoute = localStorage.getItem('route');
    if(!authRoute) {
      this._router.navigateByUrl('');
    }
    const currentUrl = this._router.url;
    if(authRoute && currentUrl !== authRoute) {
      await this._router.navigateByUrl(authRoute);
    } else {
      this._loaderService.hide();
      this._helpService.hide();
    }
  }

  finish() {
    localStorage.clear();
    window.location.href = 'https://www.fincomercio.com';
  }

  contactWhitAsesor(){
    const phone = localStorage.getItem('phone') || '';
    const message = encodeURIComponent('Hola, estoy interesado en recibir asesoría sobre la actualización a Fincomercio.');
    const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }

  downloadPDF() {
    this._securityService.getPDFUpdatingData().subscribe((response: any) => {
      const file = `${environment.serverUrl}/${response.pdfFile}`;
      const url = file;
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.download = 'actualizacionDigitalFincomercio.pdf'; // Nombre del archivo descargado
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  ngAfterViewInit(): void {
  }


}
